import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'decodeDate',
    standalone: true
})
export class DecodeDatePipe implements PipeTransform {

    transform(value: unknown, ...args: unknown[]): Date {
        if (value === null || value === undefined) {
            return null;
        }
        const input = value as string;
        if (input.match(/[0-2][0-9]\:[0-2][0-9]/)) {
            const hour = Number(input.substring(0, 2));
            const minute = Number(input.substring(3, 5));
            return new Date(0, 0, 0, hour, minute, 0, 0);
        }
        if (input.match(/20[0-9][0-9]-[0-1][0-9]-[0-3][0-9]/)) {
            const year = Number(input.substring(0, 4));
            const month = Number(input.substring(5, 7)) - 1;
            const day = Number(input.substring(8, 10));
            return new Date(year, month, day, 0, 0, 0, 0);
        }
        return new Date(input);
    }

}
